/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Compare_HomepageInputs */

const en_landing_pricing_compare_homepage = /** @type {(inputs: Landing_Pricing_Compare_HomepageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Homepage sponsor placement`)
};

const zh_landing_pricing_compare_homepage = /** @type {(inputs: Landing_Pricing_Compare_HomepageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`首页赞助曝光位`)
};

/**
* | output |
* | --- |
* | "Homepage sponsor placement" |
*
* @param {Landing_Pricing_Compare_HomepageInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_compare_homepage = /** @type {((inputs?: Landing_Pricing_Compare_HomepageInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Compare_HomepageInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_compare_homepage(inputs)
	return zh_landing_pricing_compare_homepage(inputs)
});
export { landing_pricing_compare_homepage as "landing.pricing.compare_homepage" }